import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SistemaService } from '../services/sistema.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private service: SistemaService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 503) {
          this.service.ativarModoManutencao(error.error.message);
        }
        throw error;
      })
    );
  }
}
